'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Menu = Menu;
exports.Option = Option;
exports.Input = Input;
exports.Control = Control;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// https://github.com/JedWatson/react-select

var KEY_CODE_ARROW_UP = 38;
var KEY_CODE_ARROW_DOWN = 40;

function Menu(props) {
    var inputId = props.selectProps.inputId;

    var innerProps = Object.assign({}, props.innerProps, _defineProperty({
        role: 'listbox'
    }, 'aria-labelledby', inputId + '_label'));
    return _react2.default.createElement(_reactSelect.components.Menu, Object.assign({}, props, { innerProps: innerProps }));
};

function Option(props) {
    var _Object$assign2;

    var isSelected = props.isSelected ? true : false;
    var innerProps = Object.assign({}, props.innerProps, (_Object$assign2 = {}, _defineProperty(_Object$assign2, 'aria-selected', isSelected), _defineProperty(_Object$assign2, 'role', 'option'), _Object$assign2));
    return _react2.default.createElement(_reactSelect.components.Option, Object.assign({}, props, { innerProps: innerProps }));
};

function Input(props) {
    var _attrs;

    var listboxId = props['aria-owns'];
    var _props$selectProps = props.selectProps,
        inputId = _props$selectProps.inputId,
        menuIsOpen = _props$selectProps.menuIsOpen;

    var activeDescendant = function () {
        var active = document.querySelector('#' + listboxId + ' .Select__option.Select__option--is-focused');
        return menuIsOpen && active ? active.id : null;
    }();

    var attrs = (_attrs = {
        'role': 'textbox'
    }, _defineProperty(_attrs, 'aria-multiline', false), _defineProperty(_attrs, 'aria-labelledby', inputId + '_label'), _defineProperty(_attrs, 'aria-owns', null), _defineProperty(_attrs, 'aria-expanded', null), _defineProperty(_attrs, 'aria-haspopup', null), _defineProperty(_attrs, 'aria-activedescendant', activeDescendant), _attrs);
    return _react2.default.createElement(_reactSelect.components.Input, Object.assign({}, props, attrs));
};

function Control(props) {
    var _Object$assign3;

    var _props$selectProps2 = props.selectProps,
        menuIsOpen = _props$selectProps2.menuIsOpen,
        inputId = _props$selectProps2.inputId;

    var innerProps = Object.assign({}, props.innerProps, (_Object$assign3 = {
        role: 'combobox'
    }, _defineProperty(_Object$assign3, 'aria-owns', null), _defineProperty(_Object$assign3, 'aria-expanded', menuIsOpen), _defineProperty(_Object$assign3, 'aria-labelledby', inputId + '_label'), _Object$assign3));
    return _react2.default.createElement(
        _reactSelect.components.Control,
        Object.assign({}, props, { innerProps: innerProps }),
        props.children
    );
}